export default {"src":"/_next/static/media/legpress.e25c7020.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};